import { render, staticRenderFns } from "./MediaIndex.vue?vue&type=template&id=c6c0cb66&"
import script from "./MediaIndex.vue?vue&type=script&lang=js&"
export * from "./MediaIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports